import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';

export default function ImageUploadZone({ onImageAdded, type = 'gallery' }) {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);

  const onDrop = async (acceptedFiles) => {
    if (acceptedFiles.length === 0) return;

    const file = acceptedFiles[0];

    if (!file.type.startsWith('image/')) {
      setError('Please upload an image file');
      return;
    }

    setUploading(true);
    setError(null);

    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await fetch('/api/upload', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        throw new Error('Upload failed');
      }

      const data = await response.json();
      onImageAdded(data.url, type);
    } catch (err) {
      setError('Failed to upload image');
      console.error('Upload error:', err);
    } finally {
      setUploading(false);
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'image/*': ['.jpeg', '.jpg', '.png', '.gif', '.webp']
    },
    disabled: uploading
  });

  return (
    <div
      {...getRootProps()}
      style={{
        border: '2px dashed rgba(244,241,234,0.3)',
        borderRadius: '4px',
        padding: '32px',
        textAlign: 'center',
        cursor: uploading ? 'not-allowed' : 'pointer',
        backgroundColor: isDragActive ? 'rgba(244,241,234,0.05)' : 'transparent',
        transition: 'all 0.2s ease',
        opacity: uploading ? 0.6 : 1
      }}
    >
      <input {...getInputProps()} />
      <div style={{ fontSize: '32px', marginBottom: '12px' }}>📸</div>
      {isDragActive ? (
        <p style={{ color: 'rgba(244,241,234,0.8)', margin: '0' }}>Drop image here...</p>
      ) : uploading ? (
        <p style={{ color: 'rgba(244,241,234,0.6)', margin: '0' }}>Uploading...</p>
      ) : (
        <>
          <p style={{ color: 'rgba(244,241,234,0.8)', margin: '0', fontWeight: 600 }}>
            Drag image here or click to browse
          </p>
          <p style={{ color: 'rgba(244,241,234,0.5)', margin: '8px 0 0 0', fontSize: '13px' }}>
            PNG, JPG, GIF, WebP up to 10MB
          </p>
        </>
      )}
      {error && (
        <p style={{ color: '#ff6b6b', margin: '12px 0 0 0', fontSize: '13px' }}>
          {error}
        </p>
      )}
    </div>
  );
}
